/**
 * Contact form — validates, builds API payload (module/action/bsid/form_id),
 * submits via fetch to the Leads API, and shows success/error alerts.
 * Loaded only on the contact page via route.php.
 */
(function () {
  "use strict";

  function initContactForm() {
    var form = document.getElementById("br-contact-form");
    if (!form || form.getAttribute("data-br-contact-bound") === "1") {
      return;
    }
    form.setAttribute("data-br-contact-bound", "1");

    var successEl = document.getElementById("br-contact-form-success");
    var errorEl = document.getElementById("br-contact-form-error");
    var submitBtn = document.getElementById("br-contact-submit");

    var apiUrl = (form.getAttribute("data-api-url") || "").trim();
    var bsid = (form.getAttribute("data-bsid") || "").trim();
    var formId = (form.getAttribute("data-form-id") || "").trim();
    var lang = (form.getAttribute("data-lang") || "1").trim();
    var errDefault = (form.getAttribute("data-error-network") || "").trim();

    function hideAlerts() {
      if (successEl) {
        successEl.classList.add("d-none");
      }
      if (errorEl) {
        errorEl.classList.add("d-none");
        errorEl.textContent = "";
      }
    }

    function showSuccess() {
      hideAlerts();
      if (successEl) {
        successEl.classList.remove("d-none");
        successEl.focus();
      }
    }

    function showError(msg) {
      if (!errorEl) {
        return;
      }
      hideAlerts();
      errorEl.textContent = msg || "שגיאה";
      errorEl.classList.remove("d-none");
    }

    function refreshMdbInputs() {
      var m = window.mdb;
      if (!m || typeof m.Input !== "function") {
        return;
      }
      var outlines = form.querySelectorAll(".form-outline");
      for (var i = 0; i < outlines.length; i++) {
        try {
          if (typeof m.Input.getOrCreateInstance === "function") {
            var inst = m.Input.getOrCreateInstance(outlines[i]);
            if (inst && typeof inst.update === "function") {
              inst.update();
            }
          }
        } catch (_) {}
      }
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var hp = form.querySelector('[name="br_contact_hp"]');
      if (hp && hp.value) {
        return;
      }

      if (!form.checkValidity()) {
        form.classList.add("was-validated");
        return;
      }
      form.classList.remove("was-validated");

      if (!apiUrl || !bsid || !formId) {
        showError(errDefault || "הגדרות הטופס חסרות.");
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
      }
      hideAlerts();

      var fd = new FormData(form);
      fd.delete("br_contact_hp");
      fd.set("module", "Leads");
      fd.set("action", "SubmitContactForm");
      fd.set("bsid", bsid);
      fd.set("form_id", formId);
      fd.set("lang", lang);

      fetch(apiUrl, {
        method: "POST",
        body: fd,
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then(function (res) {
          if (!res.ok) {
            throw new Error("bad status");
          }
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function (data) {
          if (data && data.status === "error") {
            showError(data.message || errDefault || "שגיאה בשליחת הטופס.");
            return;
          }
          form.reset();
          refreshMdbInputs();
          showSuccess();
        })
        .catch(function () {
          showError(errDefault || "לא ניתן לשלוח את הטופס כרגע.");
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
          }
        });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactForm, { once: true });
  } else {
    initContactForm();
  }
})();
